import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';
import { versionsManagerApiRef } from './api/types';
import { VersionsManagerClient } from './api/VersionsManagerClient';

const versionsManagerApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: versionsManagerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new VersionsManagerClient({ discoveryApi, fetchApi }),
    }),
});

const versionsManagerPage = PageBlueprint.make({
  params: {
    path: '/versions-manager',
    title: 'Version Manager',
    routeRef: rootRouteRef,
    // The page renders its own BUI <FullPage>/<Header>.
    noHeader: true,
    loader: () =>
      import('./components/VersionsManagerComponent').then(m => (
        <m.VersionsManagerComponent />
      )),
  },
});

export const versionsManagerPlugin = createFrontendPlugin({
  pluginId: 'versions-manager',
  title: 'Version Manager',
  routes: {
    root: rootRouteRef,
  },
  extensions: [versionsManagerApi, versionsManagerPage],
});

export default versionsManagerPlugin;
